module.exports = __webpack_public_path__ + "img/5.3f90100f.jpg";